// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"20ff618c","453":"cf0eef00","573":"fe1813fa","607":"48a8761e","954":"355ca294"}[chunkId] + ".chunk.js";
};